import { render, staticRenderFns } from "./ParticipantLocal.vue?vue&type=template&id=b23bc234&scoped=true&"
import script from "./ParticipantLocal.vue?vue&type=script&lang=js&"
export * from "./ParticipantLocal.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantLocal.vue?vue&type=style&index=0&id=b23bc234&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23bc234",
  null
  
)

export default component.exports